export const BASE_URL = "https://upskillmeet.com/api/v1";

export const httpHeaderConfig = Object.freeze({
  Accept: "application/json",
  ["Content-Type"]: "application/json",
});
